<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-26
    	描述：商品管理-商品编辑-规格/库存-单规格
    -->
  <div>
    <el-form-item label="销售价" :rules="[{ required: true, message: '请填写产品销售价' }]" prop="sku.product_price">
      <el-input type="number" v-model="form.sku.product_price" class="max-w460"></el-input>
     </el-form-item>
  </div> 
</template>

<script>
  export default{
    inject: ["form"],
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/supply/product/part/Single.vue